var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var EventsDataSource_1;
import { NativeEventEmitter, NativeModules, Platform } from 'react-native';
import { injectable } from '../../Decorators/Injectable';
import { EventBus } from '../../EventBus/EventBus';
import { Observable } from '../../Observable/Observable';
let EventsDataSource = EventsDataSource_1 = class EventsDataSource {
    static onEvent(event) { }
    static setOnEvent(fn) {
        EventsDataSource_1.onEvent = fn;
    }
    constructor() {
        this.events = new Map();
        this.listeners = new EventBus();
        this.debug = false;
        this.externalEvents = new Map();
        this.externalEvent = new Observable();
        this.handleExternalEvent = this.handleExternalEvent.bind(this);
        if (Platform.OS === 'android') {
            this.eventListener = new NativeEventEmitter(NativeModules.EventsEmitter).addListener('event_bus', this.handleExternalEvent);
        }
        else if (Platform.OS === 'ios' && NativeModules.EventsEmitter) {
            this.eventListener = new NativeEventEmitter(NativeModules.EventsEmitter).addListener('event_bus', this.handleExternalEvent);
        }
    }
    handleExternalEvent(event) {
        var _a;
        if (!this.externalEvents.has(event.module)) {
            this.externalEvents.set(event.module, new EventBus());
        }
        (_a = this.externalEvents.get(event.module)) === null || _a === void 0 ? void 0 : _a.get(event.event).next(event);
        this.externalEvent.next(event);
    }
    getExternalEvent() {
        return this.externalEvent;
    }
    getEvent(module, event) {
        if (!this.externalEvents.has(module)) {
            this.externalEvents.set(module, new EventBus());
        }
        return this.externalEvents.get(module).get(event);
    }
    setDebug(debug) {
        this.debug = !!debug;
    }
    setOnEvent(moduleName, onEvent) {
        this.events.set(moduleName, onEvent);
        return onEvent;
    }
    addListener(moduleName) {
        return this.listeners.get(moduleName);
    }
    parseData(data) {
        if (typeof data === 'number') {
            return `${data}`;
        }
        if (!data || typeof data === 'string') {
            return data;
        }
        if (Array.isArray(data)) {
            return data.map(this.parseData);
        }
        if (typeof data === 'object') {
            return Object.entries(data).reduce((acc, [key, value]) => {
                acc[key] = this.parseData(value);
                return acc;
            }, {});
        }
        return data;
    }
    sendEvent(moduleName, event) {
        var _a, _b;
        EventsDataSource_1.onEvent(event);
        if (Platform.OS !== 'web') {
            (_b = (_a = NativeModules.EventsModule) === null || _a === void 0 ? void 0 : _a.onEvent) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        }
        if (Platform.OS === 'web' && this.debug) {
            console.log(event);
        }
        this.listeners.next(moduleName, event);
        if (!this.events.has(moduleName)) {
            return event;
        }
        this.events.get(moduleName)(event);
        return event;
    }
    onDestroy() {
        var _a;
        (_a = this.eventListener) === null || _a === void 0 ? void 0 : _a.remove();
    }
};
EventsDataSource = EventsDataSource_1 = __decorate([
    injectable({
        type: 'singleton'
    }),
    __metadata("design:paramtypes", [])
], EventsDataSource);
export { EventsDataSource };
